module.exports = __webpack_public_path__ + "assets/img/table.cf309be4.svg";